// Ids match the seed in prisma/migrations/20260921120000_cal_event_template/migration.sql, plus id 7 in 20261009120000_cal_event_templates_tags_and_per_product_fields.
export var CalEventFieldType;
(function (CalEventFieldType) {
    CalEventFieldType[CalEventFieldType["TEXT"] = 1] = "TEXT";
    CalEventFieldType[CalEventFieldType["NUMBER"] = 2] = "NUMBER";
    CalEventFieldType[CalEventFieldType["DATE"] = 3] = "DATE";
    CalEventFieldType[CalEventFieldType["SELECT"] = 4] = "SELECT";
    CalEventFieldType[CalEventFieldType["ENTITY_REF"] = 5] = "ENTITY_REF";
    CalEventFieldType[CalEventFieldType["SYSTEM_TIMESTAMP"] = 6] = "SYSTEM_TIMESTAMP";
    CalEventFieldType[CalEventFieldType["PER_PRODUCT_NUMBER"] = 7] = "PER_PRODUCT_NUMBER";
})(CalEventFieldType || (CalEventFieldType = {}));
//# sourceMappingURL=cal-event-field-type.js.map